export default __webpack_public_path__ + "d6412cf3d9b7459cd63f15ff34b6d37d.svg";